<div class="main">
  <div class="container">
    <div class="header">
      <img
        src="../../../../../assets/images/logos/NanoH2O-Black@3x 1.png"
        alt="LG NanoH2O - Login"
        class="center"
        height="40"
        width="380"
      />
    </div>
    <div style="background-color: rgb(255, 103, 39); height: 10px"></div>
    <form [formGroup]="LoginForm" (ngSubmit)="login()">
      <input
        type="text"
        id="Username"
        name="Username"
        placeholder="Username"
        class="form-control border border-dark"
        formControlName="Username"
        [ngClass]="{
          'is-invalid': submitted && LoginForm.controls.Username.errors
        }"
        (change)="validateUsername()"
      />
      <div
        *ngIf="submitted && LoginForm.controls.Username.errors"
        class="text-danger"
        style="text-align: left"
      >
        <span *ngIf="LoginForm.controls.Username.errors.required"
          >Username is required.</span
        >
      </div>
      <input
      type="password"
      class="form-control border border-dark"
      name="password"
      placeholder="Password"
      aria-label="Password"
      formControlName="Password"
      [ngClass]="{ 'is-invalid': submitted && LoginForm.controls.Password.errors }"
      /><br />
      <button type="submit">LOGIN</button>
      <br />
      <a routerLink="/forgot-pass">Forgot Password and Username</a>
     
     
    </form>
  </div>
</div>
